export default __webpack_public_path__ + "static/media/recipients_root_background.f8437a91.jpg";